import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { gql } from '@apollo/client';
import { Challenge } from '@infl-ts/util-fetch-challenge-list';
import { useToggle } from '@infl-ts/util-hooks';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import { logQueryError } from '@infl-ts/util-query-errors';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { constVoid, flow, pipe } from 'fp-ts/function';
import * as IO from 'fp-ts/IO';
import * as t from 'io-ts';
import { Profile } from '../codecs';
import OnboardingError from '../onboarding-error';
import { OnboardingChallenge } from './onboarding-challenge';
import { jsx as _jsx } from "react/jsx-runtime";
export var onboardingChallengeFragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OnboardingChallengeFragment on Challenge {\n    id\n    description\n    banner {\n      id\n      blurhash\n    }\n    minimumAvailablePoints\n    maximumAvailablePoints\n    totalStages\n    headline\n    multiComplete\n    unseen\n    inProgress\n    expiresAt\n    savedForLater\n    remainingCompletionCount\n    memberRemainingCompletionCount\n    availableForCompletion\n    category {\n      id\n      name\n    }\n    activities {\n      id\n      state\n      currentStage {\n        position\n      }\n    }\n  }\n"])));
var useChallengeOnboarding = makeDecodedQuery(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    query ChallengeOnboarding($id: ID!) {\n      challenge: node(id: $id) {\n        ... on Challenge {\n          ...OnboardingChallengeFragment\n        }\n      }\n      profile {\n        id\n        username\n        name\n        email\n        title\n        company\n        avatarUrl\n      }\n    }\n\n    ", "\n  "])), onboardingChallengeFragment), t.type({
  challenge: nullable(Challenge),
  profile: Profile
}), t.type({
  id: t.string
}));
export default function ChallengeFlow(_ref) {
  var _ref$onboardingChalle = _ref.onboardingChallengeFlow,
      challengeID = _ref$onboardingChalle.challengeID,
      skippable = _ref$onboardingChalle.skippable,
      _ref$onComplete = _ref.onComplete,
      onComplete = _ref$onComplete === void 0 ? constVoid : _ref$onComplete;

  var _useToggle = useToggle(true),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      onboardingChallengeVisible = _useToggle2[0],
      hideOnboardingChallenge = _useToggle2[1].off;

  var challengeOnboarding = useChallengeOnboarding({
    variables: {
      id: "challenge_".concat(challengeID)
    }
  });
  return pipe(challengeOnboarding, DE.squash(function () {
    return /*#__PURE__*/_jsx(Box, {});
  }, flow(logQueryError, function () {
    return /*#__PURE__*/_jsx(OnboardingError, {});
  }), function (_ref2) {
    var challenge = _ref2.challenge,
        profile = _ref2.profile;
    return challenge && onboardingChallengeVisible ? /*#__PURE__*/_jsx(OnboardingChallenge, {
      challenge: challenge,
      profile: profile,
      canClose: skippable,
      onClose: pipe(hideOnboardingChallenge, IO.apSecond(onComplete))
    }) : null;
  }));
}